<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<div mat-dialog-content [innerHtml]="message | safe:'html'"></div>
<div mat-dialog-actions class="actions">
	<button mat-button mat-dialog-close tabindex="0" [color]="noColor">{{ noLabel }}</button>
	<button mat-raised-button [mat-dialog-close]="true" [color]="yesColor">{{ yesLabel }}</button>
</div>